import styled from "styled-components";
import {Link} from "react-router-dom";
import Container from './Container'
import { FiSettings,FiVideo } from "react-icons/fi";

const NavigationContainer = styled.div`
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
`;

const LogoContainer = styled(Link)`
    display: flex;
    align-items: center;
    text-decoration: none;
    width: 300px;
`;

const LogoIcon = styled(FiVideo)`
    width: 24px;
    height: 24px;
    color: ${(props) => props.theme.colors.default};
    padding: 12px;
    box-sizing: content-box!important;
`;

const LogoText = styled.span`
    color: ${(props) => props.theme.colors.offWhite};
    font-size: 18px;
    font-weight: 500;
`;

const SettingsContainer = styled.div`
    width: calc(100%-124px);
    flex: 1;
    display: flex;
    justify-content: flex-end;
`;

const SettingsButton = styled.button`
    color: ${(props) => props.theme.colors.default};
    background: transparent;
    border: none;
    outline: none;
    height: 24px;
    width: 24px;
    padding: 12px;
    box-sizing: content-box;
    cursor: pointer;
    transition: all .30s;
    border-radius: 5px;
    &:hover{
        background: #ddd;
    }
`;

const SettingsIcon = styled(FiSettings)`
    height: 24px;
    width: 24px;
`;

const Nav = () => {
    return (
        <Container borderBottom>
            <NavigationContainer>
                <LogoContainer to="/">
                    <LogoIcon/>
                    <LogoText>হাডেল-কানেক্টেড থাকুন মাতৃভাষায়</LogoText>
                </LogoContainer>
                <SettingsContainer>
                    <SettingsButton>
                        <SettingsIcon/>
                    </SettingsButton>
                </SettingsContainer>
            </NavigationContainer>
        </Container>
    )
}

export default Nav;